<template>
  <div class="isTxt" v-if="isTxt">
    <el-image
      v-for="(img, index) in imgList"
      :key="index"
      class="img-item"
      :src="img"
      :zoom-rate="1.2"
      :max-scale="7"
      :min-scale="0.2"
      preview-teleported
      :preview-src-list="imgList"
      fit="cover"
    />
  </div>
  <RxkUploadFile
    v-else
    class="customUpload"
    :limit="limit"
    :maxSize="20"
    :accept="accept"
    listType="picture"
    :fileList="list"
    :disabled="renderConfig.disabled"
    @handleSuccess="handleSuccess"
    @handleRemove="handleRemove"
  >
    <template #upload>
      <div class="uploadImg" :class="{ 'forbidden-upload': renderConfig.disabled }">选择图片</div>
    </template>
  </RxkUploadFile>
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, watch, unref } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkUploadFile } from '@/components/common/RxkUploadFile'
import { operateListEnum } from '@/enums/preObjectManage'
import globalEnv from '@/configs'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue'])

const list = ref<string[]>([])

const imgList = computed(() => {
  return unref(list).map(el => globalEnv.imgBaseUrl + el)
})
const accept = '.jpg,.jpeg,.png,.gif'

onMounted(() => {
  list.value = props.modelValue || props.data.value || []
})

watch(
  () => list.value,
  () => {
    if (!list.value.length) {
      emit('update:modelValue', '')
    } else {
      emit('update:modelValue', JSON.stringify(list.value))
    }
  },
  {
    deep: true
  }
)
const limit = computed(() => {
  console.log(props.data, 'pppp1')
  const columnOperateList = props.data.columnOperateList || []
  const current = columnOperateList.find(
    (item: Recordable) => item.code === operateListEnum.PICTURE_ONE
  )
  return current && current.value ? 1 : 10
})
function handleSuccess(fileList, file, res) {
  console.log(fileList, file, res)
  res.data.forEach((item: Recordable) => {
    list.value.push(item.path)
  })
}
function handleRemove(fileList: any, file: any) {
  let path = file?.response?.data?.[0]?.path
  list.value.forEach((e, i) => {
    if (e === path) list.value.splice(i, 1)
  })
}
</script>
<style lang="scss" scoped>
.customUpload {
  width: 100%;
  :deep(.el-upload) {
    width: 100%;
  }
}
.uploadImg {
  height: 32px;
  line-height: 32px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  color: #5687ff;
}

.img-item {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.forbidden-upload {
  background-color: #f5f7fa;
  cursor: not-allowed;
}
</style>
